module.exports = __webpack_public_path__ + "static/bb93643ea2556912dad00442d4663c8887e21fe5012b42cde5ac9d1c10baa95b-666fc329b7364a1e22f5006ba720968d.png";